import { BaseParameterDto } from '../../_models/base-parameter-dto';

export class BaseOwnerParametersDto extends BaseParameterDto {
    customerId: string; // 16 character starts with "R"
    communityId: number; // Account #

    constructor(customerId?: string, communityId?: number) {
        super();
        this.customerId = customerId;
        this.communityId = communityId;
    }

    getQueryString(): string {
        let url = `?clearCache=${this.clearCache}`;

        if (this.communityId) {
            url = url + `&communityId=${this.communityId}`;
        }

        if (this.customerId) {
            url = url + `&customerId=${this.customerId}`;
        }
        return url;
    }
}
